import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IcosCheckbox } from './checkbox'
import { IcosCheckboxButton } from './checkbox-button'
import { IcosCheckboxGroup } from './checkbox-group'

@NgModule({
  declarations: [IcosCheckbox, IcosCheckboxButton, IcosCheckboxGroup],
  exports: [IcosCheckbox, IcosCheckboxButton, IcosCheckboxGroup],
  imports: [CommonModule, FormsModule],
  entryComponents: [IcosCheckbox, IcosCheckboxButton, IcosCheckboxGroup],
})
export class IcosCheckboxsModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosCheckboxsModule, providers: [] }
  }
}
